import type { WorkspaceState, DocumentType } from "../../domain/quotation";
import { NumberField } from "../common/NumberField";

interface PricingSettingsProps {
  state: WorkspaceState;
  onDocumentTypeChange: (documentType: DocumentType) => void;
  onGlobalDiscountChange: (discount: number | undefined) => void;
  onGlobalMarkupChange: (markup: number | undefined) => void;
}

export function PricingSettings({
  state,
  onDocumentTypeChange,
  onGlobalDiscountChange,
  onGlobalMarkupChange
}: PricingSettingsProps) {
  return (
    <section className="panel document-settings pricing-settings" aria-label="Pricing settings">
      <div className="segmented-control" aria-label="Document type">
        <button
          type="button"
          className={state.documentType === "quotation" ? "active" : ""}
          onClick={() => onDocumentTypeChange("quotation")}
        >
          Quotation
        </button>
        <button
          type="button"
          className={state.documentType === "proforma" ? "active" : ""}
          onClick={() => onDocumentTypeChange("proforma")}
        >
          Proforma
        </button>
      </div>

      <div className="settings-grid">
        <NumberField
          id="global-discount"
          label="Global discount %"
          value={state.globalDiscount}
          max={100}
          step={0.1}
          onChange={onGlobalDiscountChange}
        />
        <NumberField
          id="global-markup"
          label="Global markup %"
          value={state.globalMarkup}
          max={100}
          step={0.1}
          onChange={onGlobalMarkupChange}
        />
      </div>
    </section>
  );
}

interface DocumentSettingsProps {
  state: WorkspaceState;
  onCustomerLinesChange: (customerLines: string) => void;
  onTermsTextChange: (termsText: string) => void;
}

export function DocumentSettings({
  state,
  onCustomerLinesChange,
  onTermsTextChange
}: DocumentSettingsProps) {
  return (
    <section className="panel document-settings" aria-label="Document settings">
      <label className="field" htmlFor="customer-lines">
        <span>Customer Details (To)</span>
        <textarea
          id="customer-lines"
          rows={3}
          value={state.customerLines}
          onChange={(event) => onCustomerLinesChange(event.currentTarget.value)}
        />
      </label>
      <label className="field" htmlFor="terms-text">
        <span>Terms</span>
        <textarea
          id="terms-text"
          rows={5}
          value={state.termsText}
          onChange={(event) => onTermsTextChange(event.currentTarget.value)}
          placeholder="One term per line"
        />
      </label>
    </section>
  );
}
